import { render, staticRenderFns } from "./menu-add-meal-to-diary.vue?vue&type=template&id=46799e20&"
import script from "./menu-add-meal-to-diary.vue?vue&type=script&lang=js&"
export * from "./menu-add-meal-to-diary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports